import * as yup from 'yup';

export const contactDetailsSchema = yup.object().shape({
  hubspotId: yup.number().required('Please enter a hubspot ID.').typeError('Hubspot ID must be a number.'),
  gustoCompanyUUID: yup.string().required('Please enter Gusto Company ID.'),
});
